import moment from 'moment'

export const isInFuture = date => moment(date, 'YYYY-MM-DD').isAfter(moment())

const pendingChanges = details => (details.Current === 'N' ? isInFuture(details.DoE) : false)

const active = ({ details }) => details && (details.Current === 'Y' || pendingChanges(details))

export default active



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/active.js